import React from 'react';
import {
  Tooltip,
  TooltipProps,
  Box,
  Flex
} from '@chakra-ui/react';
import { IconLightBulb } from 'icons';

interface CustomTooltipProps extends Omit<TooltipProps, 'children'> {
  children: React.ReactNode;
  icon?: React.ReactNode;
  indicatorColor?: string;
}

export const CustomTooltip = ({
  children,
  label,
  icon,
  indicatorColor = "teal.300",
  ...rest
}: CustomTooltipProps) => {
  return (
    <Tooltip
      hasArrow={false}
      placement="top"
      p="0"
      gutter={8}
      label={
        <Flex 
          direction="column" 
          width="100%" 
          p="0"
          position="relative"
          borderRadius="4px"
          _before={{
            content: '""',
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(90deg, rgba(0, 255, 232, 0) 0%, rgba(0, 255, 232, 0.4) 50%, rgba(0, 206, 187, 0) 100%)',
            borderRadius: '4px',
            paddingBottom: '2px',
            mask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
            maskComposite: "exclude",
          }}
        >
          <Box
            position="absolute"
            top="0"
            left="0"
            right="0"
            bottom="0"
            background="linear-gradient(180deg, rgba(79, 197, 186, 0.2) 0%, rgba(79, 197, 186, 0) 50%)"
            zIndex={-1}
            borderRadius="4px"
          />
          <Flex>
            <Flex 
              alignItems="center"
              justifyContent="center"
              bg="linear-gradient(360deg, rgba(0, 255, 232, 0) 0%, rgba(0, 255, 232, 0.2) 100%)"
              py="4"
              px="1"
              borderRadius="4px"
            >
              <IconLightBulb __css={{ path: { fill: 'rgba(79, 197, 186, 1)' } }} />
            </Flex>
            <Box 
              flex="1"
              fontSize="12px"
              lineHeight="14px"
              fontWeight="600"
              color="white.80"
              w="full"
              h="full"
              p="2"
              alignItems="center"
              justifyContent="center"
            >
              {label}
            </Box>
          </Flex>
          <Box 
            h="2px" 
            position="absolute"
            width="32px" 
            borderRadius="full"
            bottom="-7px"
            alignSelf="center" 
            bg={indicatorColor}
            mt={1}
            mb={1}
          />
        </Flex>
      }
      bg="blackAlpha.900"
      borderRadius="md"
      boxShadow="lg"
      maxW="200px"
      {...rest}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip; 